import React,{useEffect,useRef,useState} from 'react';
const {eligible,readRuntimeVersion,SUNSET}=require('./ownerRuntimeVersionRequest');
export default function OwnerRuntimeVersion({userId,isAdmin,getSession}){
  const [state,setState]=useState({busy:false,version:'',error:''});
  const [expired,setExpired]=useState(()=>Date.now()>=SUNSET);
  const request=useRef(null);
  useEffect(()=>{
    setState({busy:false,version:'',error:''});
    const timer=setTimeout(()=>{request.current?.abort();setExpired(true);setState({busy:false,version:'',error:''});},Math.max(0,SUNSET-Date.now()));
    return()=>{clearTimeout(timer);request.current?.abort();request.current=null;};
  },[userId,isAdmin]);
  if(expired||!eligible(userId,isAdmin))return null;
  async function check(){
    if(request.current)return;
    const controller=new AbortController();request.current=controller;
    setState({busy:true,version:'',error:''});
    const timeout=setTimeout(()=>controller.abort(),10000);
    try{
      const version=await readRuntimeVersion({userId,isAdmin,getSession,signal:controller.signal});
      if(!controller.signal.aborted)setState({busy:false,version,error:''});
    }catch{
      if(request.current===controller)setState({busy:false,version:'',error:'Runtime check unavailable. Sign in as the owner and try again.'});
    }finally{
      clearTimeout(timeout);if(request.current===controller)request.current=null;
    }
  }
  return <section className="panel" aria-label="Owner runtime verification" style={{marginBottom:16}}>
    <h2>Temporary runtime verification</h2>
    <p>Read-only server version check. Available until November 1, midnight Eastern.</p>
    <button type="button" className="btn btn-s" onClick={check} disabled={state.busy}>{state.busy?'Checking runtime…':'Check deployed Node.js version'}</button>
    <p role="status" aria-live="polite">{state.version?`Deployed Node.js: ${state.version}`:state.error}</p>
  </section>;
}
